import React from 'react';
import { Icon } from 'react-icons-kit';
import { ic_chevron_right } from 'react-icons-kit/md/ic_chevron_right';
import Container from 'common/components/UI/Container';
import Heading from 'common/components/Heading';
import Link from 'common/components/Link';
import Text from 'common/components/Text';
import { useStaticQuery, graphql } from 'gatsby';
import GatsbyImage from 'common/components/GatsbyImage';

import {
  Section,
  ContentWrapper,
  Illustration,
  TextContent,
} from './trackAudience.style';

const TrackAudience = () => {
  const data = useStaticQuery(graphql`
    query {
      audience: file(
        relativePath: { eq: "image/saasMinimal2/image 5.png" }
      ) {
        childImageSharp {
          gatsbyImageData(
            width: 703
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
    }
  `);
  return (
    <Section>
      <Container>
        <ContentWrapper>
          <Illustration>
            <GatsbyImage
              src={
                (data.audience !== null) | undefined
                  ? data.audience.childImageSharp.gatsbyImageData
                  : {}
              }
              alt="Illustration"
            />
          </Illustration>
          <TextContent>
            <Text
              as="span"
              className="slogan"
              content="Digital toolbox"
            />
            {/* <Heading
              className="title"
              content="Track your resources, leads, customers and projects"
            /> */}
            <Text
              className="desc"
              content="Applicat folosește Inteligența Artificială pentru a reduce
              cât mai mult erorile de analiză și interpretare
              a rezultatelor campaniilor de marketing digital.
              "
            />
            {/* <Link className="link" href="#">
              Learn More <Icon size={20} icon={ic_chevron_right} />
            </Link> */}
          </TextContent>
        </ContentWrapper>
      </Container>
    </Section>
  );
};

export default TrackAudience;
